export const getParamValue = (param: string | string[] | undefined) => {
  if (param) {
    try {
      return decodeURIComponent(Array.isArray(param) ? param[0] : param);
    } catch (error) {
      console.error(error);
    }
  }
  return undefined;
};
